import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 25
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function AlumnosSection() {
  return <section className="w-full bg-brand-card pt-6 md:pt-8 pb-8 md:pb-10 px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.h2 className="text-2xl md:text-3xl font-bold text-brand-dark text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-3">
          Más resultados reales de alumnos
        </motion.h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-4">
          {/* Lucas */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-md hover:border-brand-green/50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-default" data-id="element-5">
            <div className="bg-white border-b border-gray-200 overflow-hidden p-3" data-id="element-6">
              <img src="https://cdn.magicpatterns.com/uploads/9e6vABKDPvyW5wyVE7B7Nq/Imagen_23-3-26_a_las_2.19_p._m..jpg" alt="Dashboard de Lucas" className="w-full h-auto object-contain rounded-lg" data-id="element-7" />
            </div>
            <div className="p-6" data-id="element-8">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-9">Lucas</h3>
              <p className="mb-3" data-id="element-10">
                <span className="text-brand-green font-bold" data-id="element-11">+$21.400 USD</span>
                <span className="text-gray-500 text-sm" data-id="element-12"> en 30 días</span>
              </p>
              <p className="text-sm text-gray-500 italic leading-relaxed" data-id="element-13">
                "Aplicó el paso a paso, eligió el modelo correcto y logró
                escalar sus resultados en pocas semanas."
              </p>
            </div>
          </motion.div>

          {/* Lucía */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-md hover:border-brand-green/50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-default" data-id="element-14">
            <div className="bg-white border-b border-gray-200 overflow-hidden p-3" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/cF1SrR3YwPYcCNJWFycL8d/Imagen_23-3-26_a_las_2.13_p._m..jpg" alt="Dashboard de Lucía" className="w-full h-auto object-contain rounded-lg" data-id="element-16" />
            </div>
            <div className="p-6" data-id="element-17">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-18">Lucía</h3>
              <p className="mb-3" data-id="element-19">
                <span className="text-brand-green font-bold" data-id="element-20">+$9.200 USD</span>
                <span className="text-gray-500 text-sm" data-id="element-21"> en 30 días</span>
              </p>
              <p className="text-sm text-gray-500 italic leading-relaxed" data-id="element-22">
                "No sabía por dónde empezar y en pocas semanas logró sus
                primeras ventas reales."
              </p>
            </div>
          </motion.div>

          {/* Florencia */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-md hover:border-brand-green/50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-default" data-id="element-23">
            <div className="bg-white border-b border-gray-200 overflow-hidden p-3" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/2CkVaWH52XAhMUAwj1i4A4/Imagen_23-3-26_a_las_2.16_p._m..jpg" alt="Dashboard de Florencia" className="w-full h-auto object-contain rounded-lg" data-id="element-25" />
            </div>
            <div className="p-6" data-id="element-26">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-27">
                Florencia
              </h3>
              <p className="mb-3" data-id="element-28">
                <span className="text-brand-green font-bold" data-id="element-29">+$4.300 USD</span>
                <span className="text-gray-500 text-sm" data-id="element-30"> en 30 días</span>
              </p>
              <p className="text-sm text-gray-500 italic leading-relaxed" data-id="element-31">
                "Empezó con miedo, pero siguiendo el método pudo generar
                ingresos desde su casa."
              </p>
            </div>
          </motion.div>
        </motion.div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.3
      }} data-id="element-32">
          <p className="text-gray-700 font-medium text-lg mb-3" data-id="element-33">
            Acceso inmediato después del pago
          </p>

          <a href="#" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-lg px-12 py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 cursor-pointer" data-id="element-34">
            🔥 Quiero empezar ahora
          </a>
        </motion.div>
      </div>
    </section>;
}